import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'
//import TreeView from "../CommonComponents/TreeView";

const Shop = () => {
  return (
    <div>
        <SearchNav/>
        <h1 className='p-3'>Shopv2</h1>
        
    </div>
  )
}

export default Shop